import ActionBar from './ActionBar'
import List from './List'
import CategoryDetail from './CategoryDetail'
import {connect} from 'react-redux'
import {
  categoriesPageRequest,
  deleteCategory,
  cancelDelete,
  submitAssignToItem
} from 'actions/library/category'
import LibraryDeleteModal from 'components/LibraryDeleteModal'
import AssignToItemModal from './AssignToItemModal'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {isDirty} from 'redux-form'
import {push} from 'react-router-redux'
import {browserHistory} from 'react-router'
import {askConfirmAction} from 'actions/confirm-action'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import NoDataAndLoading from 'components/NoDataAndLoading'
import * as mpLibraryCategory from 'mixpanel/library/category'

class Category extends React.Component {
  render () {
    let {showDeleteModal, deletedCategory, showAssignToItemModal, openRightColumn, showLoadingSpinnerPage, categories} = this.props
    const categoryName = deletedCategory ? deletedCategory.name : ''
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={categories.length === 0}
              title='No Data To Display'
              description='' />
            <List />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <CategoryDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        {showAssignToItemModal &&
          <AssignToItemModal onSubmit={this._onSubmit} />
        }
        <LibraryDeleteModal
          showDeleteModal={showDeleteModal}
          onHide={this._onHideModal}
          title='Category'
          name={categoryName}
          onDelete={this._onDelete}
        />
        <ConfirmActionModal />
      </PageWrapper>
    )
  }

  componentDidMount () {
    const {expired} = this.props
    if (!expired) {
      this.props.dispatch(categoriesPageRequest())
      browserHistory.listenBefore((location) => {
        if (this.props.isDirtyCategory && !this.props.nextAction) {
          this.props.dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  _onHideModal = () => {
    this.props.dispatch(cancelDelete())
  }

  _onDelete = () => {
    let {dispatch, categories, deletedCategory} = this.props
    mpLibraryCategory.libraryCategoryDelete({name: deletedCategory.name})
    dispatch(deleteCategory(deletedCategory.id, categories))
  }

  _onSubmit = (values) => {
    const {categories, items} = this.props
    let name = null
    let itemName = []
    categories.forEach(category => { if (category.id === values.id) name = category.name })
    values.itemIds.forEach(id => {
      items.forEach(item => {
        if ('' + id === '' + item.id) {
          itemName.push(item.name)
        }
      })
    })
    mpLibraryCategory.libraryCategoryAssignToItems({name: name, itemNames: itemName})
    this.props.dispatch(submitAssignToItem({item_ids: values.itemIds}, values.id))
  }
}

function mapStateToProps (state) {
  let {categories, showDeleteModal, deletedCategory, showAssignToItemModal, openRightColumn, assignToItems: {items}} = state.library.category
  let isDirtyCategory = isDirty('category')(state)
  let nextAction = state.confirmAction.nextAction
  let {showLoadingSpinnerPage} = state.loadingSpinner
  const {expired} = state.subscriptionExpired
  return {
    categories,
    showDeleteModal,
    deletedCategory,
    showAssignToItemModal,
    isDirtyCategory,
    nextAction,
    openRightColumn,
    showLoadingSpinnerPage,
    expired,
    items
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(Category)



// WEBPACK FOOTER //
// ./app/pages/Library/Category/Category.js